import { TradeBlotterActions, TradeBlotterActionTypes } from './TradeBlotterActions';
import { TradeBlotter } from '../../model/TradeBlotter';
import { Json } from '../../model/Json';

export interface TradeBlotterState {
  total: number;
  records: Json<string, TradeBlotter>;
  message: string;
  status: string;
}

export const initialState: TradeBlotterState = {
  total: 0,
  records: new Json<string, TradeBlotter>(),
  message: null,
  status: null
};

export function tradeBlotterReducer(state: TradeBlotterState = initialState, action: TradeBlotterActions): TradeBlotterState {
  switch (action.type) {
    case TradeBlotterActionTypes.InitTradeBlotters: {
      const blotters = {};
      // Using tradeId + type as a composite key, because tradeId alone might not be unique across spot and futures
      action.payload.records.forEach(t => blotters[`${t.tradeId}_${t.type}`] = t);
      return {
        ...state,
        records: blotters,
        total: action.payload.total,
        message: action.payload.message,
        status: action.payload.status
      };
    }
    case TradeBlotterActionTypes.UpdateTradeBlotter: {
      return {
        ...state,
        records: {
          ...state.records,
          [`${action.payload.tradeId}_${action.payload.type}`]: action.payload
        }
      };
    }
    case TradeBlotterActionTypes.RemoveTradeBlotter: {
      const { [action.payload]: toRemoved, ...rest} = state.records;
      return {
        ...state,
        records: rest
      };
    }
    case TradeBlotterActionTypes.AddTradeBlotter: {
      return {
        ...state,
        records: {
          ...state.records,
          [`${action.payload.tradeId}_${action.payload.type}`]: action.payload
        }
      };
    }
  }
  return state;
}

export const initTradeBlotterState = (state: TradeBlotterState) => state;
